import SwabSampleAnalysisListStore from './swab_sample.list';

export const swabSampleAnalysis = {
  list: SwabSampleAnalysisListStore
};
